// extracted by mini-css-extract-plugin
export var contributedPages = "entity-module--contributedPages--VUWYa";
export var headerCentered = "entity-module--headerCentered--VuS27";
export var hero = "entity-module--hero--jlJQO";
export var heroImageCopyright = "entity-module--heroImageCopyright--1DxR3";
export var listPages = "entity-module--listPages--8AgTl";
export var title = "entity-module--title--wpwTK";